import React from 'react';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { FixedFooter, FixedFooterButton } from '@components';
import { ROUTES, useNavigation } from '@navigation';
import {
	useSelectedAccount,
	useBankTerms,
	useSoftwareTerms,
	useNavigationStep,
	useNavigationStore,
	useSelectedSolution,
	useUserInput,
	useIsOperator,
} from '@store';

export const FixedFooterPlaceholder: React.FC = () => {
	const {
		subscriptionTermsAndConditionsSoftware,
		subscriptionTermsAndConditionsBank,
		subscriptionSelectAccount,
		integratedSolutionSelectAccount,
		integratedSolutionTermsAndConditionsBank,
		integratedSolutionSelectSolution,
		subscriptionSelectPlan,
	} = ROUTES;
	const t = useTranslation();
	const { back, next } = useNavigation();
	const { termsWereAccepted: softwareTermsAccepted, debitWasAccepted: debitAccepted } = useSoftwareTerms();
	const { termsWereAccepted: bankTermsAccepted } = useBankTerms();
	const { selectedAccount } = useSelectedAccount();
	const { planId } = useUserInput();
	const { current: currentRoute } = useNavigationStep();
	const solution = useSelectedSolution();
	const { flow } = useNavigationStore();
	const isOperator = useIsOperator();

	const isCurrentRoute = (route: string) => currentRoute === route;

	const isDisabled =
		flow === 'subscription'
			? {
					[subscriptionSelectPlan]: isCurrentRoute(subscriptionSelectPlan) && !planId,
					[subscriptionSelectAccount]: isCurrentRoute(subscriptionSelectAccount) && !selectedAccount,
					[subscriptionTermsAndConditionsBank]:
						isCurrentRoute(subscriptionTermsAndConditionsBank) && !bankTermsAccepted,
					[subscriptionTermsAndConditionsSoftware]:
						isCurrentRoute(subscriptionTermsAndConditionsSoftware) &&
						(!softwareTermsAccepted || !debitAccepted),
			  }
			: {
					[integratedSolutionSelectSolution]: isCurrentRoute(integratedSolutionSelectSolution) && !solution,
					[integratedSolutionSelectAccount]:
						isCurrentRoute(integratedSolutionSelectAccount) && !selectedAccount,
					[integratedSolutionTermsAndConditionsBank]:
						isCurrentRoute(integratedSolutionTermsAndConditionsBank) && !bankTermsAccepted,
			  };

	let button: FixedFooterButton | undefined = undefined;
	if (!isCurrentRoute(subscriptionSelectPlan)) {
		button = {
			onClick: back,
			text: t('general.back'),
		};
	}
	return (
		<FixedFooter
			rightButton={{
				onClick: next,
				disabled: isOperator || isDisabled[currentRoute],
				text: t('general.continue'),
			}}
			leftButton={button}
		/>
	);
};
